import clsx from 'clsx';
import type { FunctionComponent, ReactNode } from 'react';

type PageHeadingProps = {
    readonly actions?: ReactNode;
    readonly children?: ReactNode;
    readonly className?: string;
    readonly title: ReactNode;
};

export const PageHeading: FunctionComponent<PageHeadingProps> = ({ actions, children, className, title }) => (
    <div className={clsx('flex min-w-0 shrink-0 flex-col gap-xs px-m pt-xxs', className)} data-testid="page-heading">
        <h1 className="m-0 text-balance text-h3 text-text-heading">{title}</h1>
        {children === undefined && actions === undefined ? null : (
            <div className="flex min-w-0 items-end gap-xxl">
                <div className="min-w-0">{children}</div>
                {actions === undefined ? null : <div className="flex min-w-0 flex-1 justify-end">{actions}</div>}
            </div>
        )}
    </div>
);
